module.exports = __webpack_public_path__ + "img/Friday.45c7c297.jpg";